// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/CourierModal/pages/styles/ReceiptMapPage.module.css */

.ReceiptMapPage_root__nfuJG {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;       /* ключ: позволяет дочерним flex-элементам занимать всю высоту */
 }


.ReceiptMapPage_loading__flbZX,
.ReceiptMapPage_error__TLqti {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 1.2rem;
  color: #555;
}

.ReceiptMapPage_error__TLqti p {
  margin-bottom: 1rem;
}

.ReceiptMapPage_backButton__4kSnZ {
  position: absolute;           /* поверх карты */
  top: 16px;                    /* от верхнего края модалки */
  left: 16px;                   /* от левого края модалки */
  z-index: 100;                 /* над слоем карты */
  background: rgba(255,255,255,0.8);
  border: none;
  color: #007bff;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 4px;
}

.ReceiptMapPage_mapContainer__2hpQM {
  position: absolute;
  top: 61px;    /* top: 56px; или top: 0px; */
  bottom: 50px;    /* до самого низа модалки */
  left: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/ReceiptMapPage.module.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa,QAAQ,gEAAgE;CACtF;;;AAGD;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,YAAY,iBAAiB;EAC/C,SAAS,qBAAqB,6BAA6B;EAC3D,UAAU,oBAAoB,2BAA2B;EACzD,YAAY,kBAAkB,oBAAoB;EAClD,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS,KAAK,6BAA6B;EAC3C,YAAY,KAAK,2BAA2B;EAC5C,OAAO;EACP,QAAQ;AACV","sourcesContent":["/* src/modules/Courier/pages/CourierModal/pages/styles/ReceiptMapPage.module.css */\r\n\r\n.root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;       /* ключ: позволяет дочерним flex-элементам занимать всю высоту */\r\n }\r\n\r\n\r\n.loading,\r\n.error {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  font-size: 1.2rem;\r\n  color: #555;\r\n}\r\n\r\n.error p {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.backButton {\r\n  position: absolute;           /* поверх карты */\r\n  top: 16px;                    /* от верхнего края модалки */\r\n  left: 16px;                   /* от левого края модалки */\r\n  z-index: 100;                 /* над слоем карты */\r\n  background: rgba(255,255,255,0.8);\r\n  border: none;\r\n  color: #007bff;\r\n  font-size: 1rem;\r\n  padding: 0.5rem 1rem;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\n.mapContainer {\r\n  position: absolute;\r\n  top: 61px;    /* top: 56px; или top: 0px; */\r\n  bottom: 50px;    /* до самого низа модалки */\r\n  left: 0;\r\n  right: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ReceiptMapPage_root__nfuJG`,
	"loading": `ReceiptMapPage_loading__flbZX`,
	"error": `ReceiptMapPage_error__TLqti`,
	"backButton": `ReceiptMapPage_backButton__4kSnZ`,
	"mapContainer": `ReceiptMapPage_mapContainer__2hpQM`
};
export default ___CSS_LOADER_EXPORT___;
